import { toast } from 'sonner';

const durations = { success: 4000, info: 4000, error: 8000, warning: 8000, loading: Infinity };
export function createFeedback(isCurrent = () => true) {
  const send = (kind, message, options = {}) => {
    if (!isCurrent()) return undefined;
    return toast[kind](message, { duration: durations[kind], ...options });
  };
  return Object.assign((message, options) => send('info', message, options),
    Object.fromEntries(Object.keys(durations).map(kind => [kind, (message, options) => send(kind, message, options)])),
    { isCurrent, dismiss: id => { if (isCurrent()) toast.dismiss(id); } });
}
export const feedback = createFeedback();
